import React, { createContext, useContext, useCallback } from 'react';

/**
 * ThemeContext — kept as a no-op stub.
 *
 * Earlier versions of the storefront supported per-category color
 * theming by writing `<html data-theme="water-outdoor">` and matching
 * `[data-theme="water-outdoor"]` blocks in `index.css`. The Phase 1A
 * design system (modern & minimal premium) replaces all category
 * theming with a single brand color, so the underlying CSS rules
 * have been removed.
 *
 * `setTheme()` and `clearTheme()` are still callable because
 * `CategoryLanding.js` invokes them on mount/unmount; making them
 * no-ops here means we don't have to touch CategoryLanding.js
 * during Phase 1. The full removal — including this stub and the
 * call sites — is queued for Phase 3 cleanup.
 */
const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const setTheme = useCallback(() => { /* no-op — see file header */ }, []);
  const clearTheme = useCallback(() => { /* no-op — see file header */ }, []);

  return (
    <ThemeContext.Provider value={{ currentTheme: null, setTheme, clearTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
